import { createAsyncThunk } from '@reduxjs/toolkit';
import { VERIFY_ABHA_OTP } from '@custom/constant';
import { abhaVerifyOtpType } from '@custom/Utils/constants/interfaces';

const verifyAbhaOtpApi = createAsyncThunk(
    'abha/verify',
    async (payload: abhaVerifyOtpType, { rejectWithValue }) => {
        try {
            const token = sessionStorage.getItem('token') || localStorage.getItem('token');
            const response = await fetch(VERIFY_ABHA_OTP, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Failed to verify otp');
            }

            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export default verifyAbhaOtpApi